import React from "react";
import { Outlet } from "react-router-dom";
import Head from "./head/Head";
import Footer from "./footer/Footer";
import { ToastContainer } from "react-toastify";

const Layout = ({ title, ...props }) => {
  return (
    <>
      <Head title={!title && "Loading"} />
      <div className="nk-app-root">
        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content">
            <Outlet />
            <Footer />
          </div>
        </div>
      </div>
      <ToastContainer autoClose={3500} position="top-center" />
    </>
  );
};
export default Layout;
